import React from 'react';
import {PhoneHQSpinner, PhoneHQButton, PhoneHQModal} from 'ch3-ui-lib';

interface InviteProgressDialogProps {
    open: boolean;
    invited: number;
    total: number;
    error?: boolean;
    onClose: () => void;
}

export const InviteProgressDialog: React.FC<InviteProgressDialogProps> = ({
    open,
    invited,
    total,
    error,
    onClose,
}) => {
    const percent = total > 0 ? Math.min(100, Math.round((invited / total) * 100)) : 0;

    return (
        <PhoneHQModal
            open={open}
            width={440}
            hideClose={!error}
            footer={error ? <PhoneHQButton variant="secondary" className="px-5" onClick={onClose}>Close</PhoneHQButton> : undefined}
            // Only dismissible once it has failed; otherwise it stays up until done.
            onOpenChange={(isOpen: boolean) => {
                if (!isOpen && error) onClose();
            }}
            title={error ? 'Could not add all members' : 'Adding members'}
        >
            {error ? (
                <p className="m-0 text-callout font-normal text-ink-muted">
                    Inviting members failed after {invited} of {total}. The conversation was
                    created, but some members may not have been invited. You can invite them
                    again from the conversation.
                </p>
            ) : (
                <div className="flex flex-col gap-3">
                    <div className="flex items-center gap-2 text-sm">
                        <PhoneHQSpinner />
                        <span>Inviting {invited} of {total} members…</span>
                    </div>
                    <div className="h-2 w-full rounded-full bg-line overflow-hidden">
                        <div
                            className="h-full rounded-full bg-brand transition-all duration-300 ease-out"
                            style={{ width: `${percent}%` }}
                        />
                    </div>
                    <div className="text-xs text-ink-muted">
                        Large groups can take a moment. You can keep this open while members are added.
                    </div>
                </div>
            )}
        </PhoneHQModal>
    );
};
